/**
 * Session-scoped "newly added partners" cues for Matrix columns
 * (Add Partners wizard, Manage Save, or named-view Edit net-adds).
 * Cleared when: tab/session ends; user interacts with that column; toolbar Refresh
 * (Wave 0 / B3). Not used for two-way-match "new" cues — those must survive Refresh.
 *
 * Scope: omitted / null viewId = Master. Positive view id = that named view only.
 */

const STORAGE_KEY = 'ae:newPartnerIds'
const VIEW_KEY_PREFIX = STORAGE_KEY + ':view:'

function keyFor (viewId) {
  const n = Number(viewId)
  if (Number.isFinite(n) && n > 0) return VIEW_KEY_PREFIX + n
  return STORAGE_KEY
}

function readIds (viewId) {
  try {
    const raw = window.sessionStorage.getItem(keyFor(viewId))
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
  } catch (e) {
    return []
  }
}

function writeIds (ids, viewId) {
  const key = keyFor(viewId)
  const unique = [...new Set(ids.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))]
  if (!unique.length) {
    window.sessionStorage.removeItem(key)
    return
  }
  window.sessionStorage.setItem(key, JSON.stringify(unique))
}

export function getNewPartnerIds (viewId) {
  return new Set(readIds(viewId))
}

export function addNewPartnerIds (ids, viewId) {
  const next = readIds(viewId)
  ;(ids || []).forEach((id) => {
    const n = Number(id)
    if (Number.isFinite(n) && n > 0) next.push(n)
  })
  writeIds(next, viewId)
}

export function isNewPartner (id, viewId) {
  const n = Number(id)
  if (!Number.isFinite(n) || n <= 0) return false
  return getNewPartnerIds(viewId).has(n)
}

export function markPartnerSeen (id, viewId) {
  const n = Number(id)
  if (!Number.isFinite(n) || n <= 0) return false
  const before = readIds(viewId)
  const after = before.filter((x) => x !== n)
  if (after.length === before.length) return false
  writeIds(after, viewId)
  return true
}

export function clearNewPartnerCues () {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
    const remove = []
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const k = window.sessionStorage.key(i)
      if (k && k.indexOf(VIEW_KEY_PREFIX) === 0) remove.push(k)
    }
    remove.forEach((k) => window.sessionStorage.removeItem(k))
  } catch (e) {
    /* ignore */
  }
}
